export default {
  clickedButton_registerSingleHarvest: 'clickedButton_registerSingleHarvest',
  clickedButton_registerMultipleHarvest:
    'clickedButton_registerMultipleHarvest',
  clickedButton_saveSingleHarvest: 'clickedButton_saveSingleHarvest',
  clickedButton_saveMultipleHarvest: 'clickedButton_saveMultipleHarvest',
}
